// extracted by mini-css-extract-plugin
module.exports = {"container":"AnnualReportItem_container__16C70","title":"AnnualReportItem_title__70oEb"};